// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapperMain":"AccountPaymentsPage_layoutWrapperMain__JvLSa"};